import React from 'react';
import { Modal, Table, Tag, Typography, Empty } from 'antd';
import moment from 'moment';

const { Text } = Typography;

const ApprovalHistoryModal = ({ visible, onCancel, historyData }) => {
    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text) => <Text strong>{text || 'N/A'}</Text>
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            render: (text) => text || 'No notes provided'
        },
        {
            title: 'Date & Time',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (text) => text ? moment(text).format('MMM Do YYYY, h:mm a') : 'N/A'
        }
    ];

    return (
        <Modal
            title="Approval History"
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width={700}
        >
            {historyData && Array.isArray(historyData) && historyData.length > 0 ? (
                <Table
                    dataSource={historyData}
                    columns={columns}
                    rowKey="id"
                    pagination={false}
                    size="middle"
                />
            ) : (
                <Empty description="No approval history found" />
            )}
        </Modal>
    );
};

export default ApprovalHistoryModal;
